module.exports = __webpack_public_path__ + "img/dehsen.48de4103.png";